module.exports = __webpack_public_path__ + "static/img/3.43bc5f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/3.png
// module id = B6eR
// module chunks = 0